<template>
  <v-container>
    <v-row v-if="showMenu">
      <v-col cols="4">
        <v-card ripple height="150" elevation="15" rounded="xl" @click="listProjects">
          <v-card-title class="justify-center align-center fill-height">
            <h1 class="headline">Projects</h1>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card ripple height="150" elevation="15" rounded="xl" @click="$router.push({ name: 'Console' })">
          <v-card-title class="justify-center align-center fill-height">
            <h1 class="headline">Console</h1>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card ripple height="150" elevation="15" rounded="xl" @click="exportDB">
          <v-card-title class="justify-center align-center fill-height">
            <h1 class="headline">Export DB</h1>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card ripple height="150" elevation="15" rounded="xl" @click="logginUserInfo">
          <v-card-title class="justify-center align-center fill-height">
            <h1 class="headline">User</h1>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <template v-if="showProjects">
      <button @click="
        showMenu = true;
      showProjects = false;
      ">
        Menu
      </button>

      <br />

      <label style="display: block" for="">Log API URL</label>
      <input style="width: 100%" type="url" name="" id="" v-model="logsApi" />

      <table class="table-auto">
        <thead>
          <th>Patient</th>
          <th>Transferable</th>
          <th>Unlock</th>
          <th>Actions</th>
        </thead>
        <tbody>
          <tr v-for="project in projects" :key="project.uuid">
            <td>{{ project.patient.fullname }}</td>
            <td>{{ project.transferable }}</td>
            <td><a @click="unlockProject(project.uuid)">Unlock</a></td>

            <td>
              <a @click="submitRawData(project)">Send raw data</a>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-if="showLogginUser">
      <v-row>
        <v-btn @click="
          showMenu = true;
        showLogginUser = false;
        ">
          Menu
        </v-btn>
      </v-row>
      <v-row>
        <pre>{{ logginUser }}</pre>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { productsObject } from "@/utils";

import axios from "axios";

import { exportDB } from "dexie-export-import";

export default {
  name: "AppDebugView",

  data() {
    return {
      showMenu: true,
      showProjects: false,
      showLogginUser: false,
      logginUser: {},

      logsApi:
        "https://alan-logs.01fcd5fc-1999-4318-8a8d-fa03a38e9dd5.nodes.k8s.fr-par.scw.cloud",

      projects: [],
      projectsHeader: [
        { text: "Patient", value: "patient.fullname" },
        { text: "Transferable", value: "transferable" },
      ],
    };
  },

  methods: {
    async listProjects() {
      this.showMenu = false;
      this.showProjects = true;

      this.projects = await this.$db.projects.toArray();
    },

    async exportDB() {
      const db = this.$db;

      const blob = await exportDB(db, { prettyJson: true });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "db.json";
      a.click();
    },

    logginUserInfo() {
      this.showMenu = false;
      this.showLogginUser = true;
      this.$db.user
        .toCollection()
        .first()
        .then((res) => {
          this.logginUser = res;
        });
    },

    async submitRawData(project) {
      try {
        const productTableName =
          productsObject[project.product_model].tableName;

        const localProduct = await this.$db[productTableName].get(
          project.local_version
        );

        const data = {
          project: project,
          product: localProduct,
        };

        const url = `${this.logsApi}/sendRawData`;
        await axios.post(url, {
          data: JSON.stringify(data),
        });

        alert("Logs send");
      } catch (error) {
        alert(`Something wrong: ${error.message}`);
        console.error(error);
      }
    },

    async unlockProject(project_uuid) {
      try {
        await this.$db.projects.update(project_uuid, {
          idc_locked: false,
        });
      } catch (error) {
        alert(error);
      }
    },
  },
};
</script>

<style lang="scss">
.app-debug-view {
  height: 100%;
}

.table-auto {
  table-layout: auto;
  width: 100%;
  margin: 3.5rem 0;

  th {
    text-align: left;
    font-size: 1.375rem !important;
  }

  td {
    padding: 1.5rem 0;
  }
}
</style>
